// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_BOOLEAN_YES_WITH_ADAPTERS = "s adapt\u00e9ry";
export const STROLLER_BOOLEAN_YES_WITH_COMBO = "p\u0159i kombinaci";
export const STROLLER_BOOLEAN_YES_WITHOUT_ADAPTERS = "bez adapt\u00e9r\u016f";
